// 日本の都道府県の日本語→中国語対応表
const JPN_REGION_JA_TO_CN = {
  北海道: '北海道',
  青森県: '青森县',
  岩手県: '岩手县',
  宮城県: '宫城县',
  秋田県: '秋田',
  山形県: '山形县',
  福島県: '福岛县',
  茨城県: '茨城县',
  栃木県: '枥木县',
  群馬県: '群马县',
  埼玉県: '埼玉',
  千葉県: '千叶县',
  東京都: '东京',
  神奈川県: '神奈川县',
  新潟県: '新泻县',
  富山県: '富山县',
  石川県: '石川县',
  福井県: '福井县',
  山梨県: '山梨县',
  長野県: '长野县',
  岐阜県: '岐阜县',
  静岡県: '静冈县',
  愛知県: '爱知县',
  三重県: '三重县',
  滋賀県: '滋贺县',
  京都府: '京都',
  大阪府: '大阪',
  兵庫県: '兵库县',
  奈良県: '奈良县',
  和歌山県: '和歌山县',
  鳥取県: '鸟取县',
  島根県: '岛根县',
  岡山県: '冈山县',
  広島県: '广岛',
  山口県: '山口县',
  徳島県: '德岛县',
  香川県: '香川县',
  愛媛県: '爱媛县',
  高知県: '高知县',
  福岡県: '福冈县',
  佐賀県: '佐贺县',
  長崎県: '长崎县',
  熊本県: '熊本县',
  大分県: '大分县',
  宮崎県: '宫崎县',
  鹿児島県: '鹿儿岛县',
  沖縄県: '冲绳县'
}

export default {
  JPN_REGION_JA_TO_CN
}
